import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type InheritedSettingsBannerContextValue = {
  /** Child inherited-setting info callout is on screen; hide the separate parent-hierarchy banner. */
  childInheritedInfoBannerActive: boolean;
  setChildInheritedInfoBannerActive: (active: boolean) => void;
};

const InheritedSettingsBannerContext = createContext<InheritedSettingsBannerContextValue | null>(
  null,
);

export function InheritedSettingsBannerProvider({ children }: { children: React.ReactNode }) {
  const [childInheritedInfoBannerActive, setActive] = useState(false);
  const setChildInheritedInfoBannerActive = useCallback((active: boolean) => {
    setActive(active);
  }, []);

  const value = useMemo(
    () => ({ childInheritedInfoBannerActive, setChildInheritedInfoBannerActive }),
    [childInheritedInfoBannerActive, setChildInheritedInfoBannerActive],
  );

  return (
    <InheritedSettingsBannerContext.Provider value={value}>
      {children}
    </InheritedSettingsBannerContext.Provider>
  );
}

export function useInheritedSettingsBannerContext(): InheritedSettingsBannerContextValue {
  const context = useContext(InheritedSettingsBannerContext);
  if (!context) {
    return {
      childInheritedInfoBannerActive: false,
      setChildInheritedInfoBannerActive: () => {},
    };
  }
  return context;
}
